<template>
  <main class="login-page afro-bg">
    <section class="login-card paper-panel">
      <img class="login-logo" src="/assets/afrogato/logo-afrogato.png" alt="Afrogato Cafe" />
      <p class="card-kicker">Bienvenido</p>
      <h1>Iniciar sesion</h1>

      <form class="login-form" @submit.prevent="handleLogin">
        <label>
          <span class="afro-label">Correo o usuario</span>
          <input v-model.trim="email" class="afro-input" type="text" autocomplete="username" placeholder="tu@email.com" />
        </label>
        <label>
          <span class="afro-label">Contrasena</span>
          <input v-model="password" class="afro-input" type="password" autocomplete="current-password" placeholder="Tu contrasena" />
        </label>
        <button class="afro-btn primary-login" type="submit" :disabled="alreadyLoggingIn">
          {{ alreadyLoggingIn ? 'Entrando...' : 'Entrar a mi wallet' }}
        </button>
      </form>

      <p class="login-note">Inicia sesion para consultar tus puntos, guardar tu QR y canjear tus bebidas favoritas.</p>

      <div class="login-actions">
        <router-link to="/registrarse" class="secondary-action">Registrarme</router-link>
        <router-link to="/menu" class="secondary-action">Ver menu</router-link>
      </div>
    </section>
  </main>
</template>

<script>
import { mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'UserLogin',
  data() {
    return { email: '', password: '', alreadyLoggingIn: false }
  },
  methods: {
    ...mapActions(['login']),
    async handleLogin() {
      if (this.alreadyLoggingIn) return
      if (!this.email || !this.password) return alert('Completa tu correo y contrasena')
      this.alreadyLoggingIn = true
      try {
        const response = await axios.post('/api/login_post', { email: this.email, password: this.password })
        if (response.data && response.data.success) {
          await this.login(response.data.user)
          this.$router.push('/wallet')
        } else {
          alert((response.data && response.data.error) || 'Usuario o contrasena incorrectos')
        }
      } catch (_error) {
        alert('Error en el servidor, intenta de nuevo mas tarde.')
      } finally {
        this.alreadyLoggingIn = false
      }
    }
  }
}
</script>

<style scoped>
.login-page { min-height: 100vh; display: grid; place-items: center; padding: clamp(16px, 4vw, 46px); }
.login-card { width: min(100%, 470px); padding: clamp(24px, 4vw, 36px); text-align: center; position: relative; overflow: hidden; z-index: 1; }
.login-card::before { content: ''; position: absolute; inset: 9px; border: 1px dashed rgba(38,51,31,.36); pointer-events: none; }
.login-logo { width: min(178px, 48vw); display: block; margin: -8px auto 6px; filter: drop-shadow(0 10px 18px rgba(0,0,0,.16)); }
.card-kicker { margin: 0 0 8px; color: var(--afro-gold); font-weight: 1000; text-transform: uppercase; letter-spacing: .16em; }
h1 { margin: 0 0 22px; font-family: var(--afro-text-serif); font-size: clamp(38px, 8vw, 52px); color: var(--afro-ink); }
.login-form { display: grid; gap: 14px; text-align: left; }
.primary-login { margin-top: 8px; width: 100%; min-height: 52px; }
.login-note { margin: 24px auto 16px; max-width: 360px; color: rgba(38,51,31,.72); font-weight: 800; line-height: 1.45; }
.login-actions { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.secondary-action { min-height: 46px; display: grid; place-items: center; border: 1px solid rgba(38,51,31,.18); border-radius: 999px; background: rgba(255,248,230,.54); color: var(--afro-olive); font-weight: 1000; text-decoration: none; }
.secondary-action:hover { background: rgba(38,51,31,.1); }
@media (max-width: 520px) { .login-page { padding: 14px; } .login-card { padding: 23px; } .login-actions { grid-template-columns: 1fr; } }
</style>
